/**
 * Every section of the site, in the order it appears in the navigation.
 *
 * Adding a new part of this place is: write the page component, add one entry
 * here. Nothing else needs to know about it — the nav, the routing and the
 * home page all read from this list.
 */
import type { ComponentType } from 'react'
import Reading from './Reading.tsx'
import Names from './Names.tsx'
import Notebooks from './Notebooks.tsx'
import Together from './Together.tsx'
import Groundwork from './Groundwork.tsx'

export type Section = {
  path: string
  label: string
  /** Shown under the title on the home page. Keep it to one line. */
  blurb: string
  Component: ComponentType
}

export const SECTIONS: Section[] = [
  {
    path: '/reading',
    label: 'Good news',
    blurb: 'Encouraging things people have written lately about raising children.',
    Component: Reading,
  },
  {
    path: '/names',
    label: 'Names',
    blurb: 'Three and a half thousand of them. Keep the ones you love.',
    Component: Names,
  },
  {
    path: '/together',
    label: 'Both of us',
    blurb: 'Answer apart, read together. Neither one opens until both are in.',
    Component: Together,
  },
  {
    path: '/groundwork',
    label: 'Groundwork',
    blurb: 'What would have to be true, and who might know something you don\'t.',
    Component: Groundwork,
  },
  {
    path: '/notebooks',
    label: 'Notebooks',
    blurb: 'Somewhere to put the thoughts that need saying out loud.',
    Component: Notebooks,
  },
]
